import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChart7"><Path d="M3.5 9.17H9.5L9.5 3.5L3.5 3.5L3.5 9.17ZM3.5 9.17L15 9.16992V14.8399L3.5 14.8399M3.5 9.17V14.8399M3.5 14.8399V20.5099H20.5V14.8399L3.5 14.8399ZM3.5 1.5V22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChart7;
